<template>
	<div class="container">
		<div class="fill_top">
			<div class="fill_top_head">
				<div class="fill_top_head_photo">
					<img :src="ticketActivity.imageurl" />
				</div>
				<div class="fill_top_head_text">
					<p>{{ticketActivity.title}}</p>
					<p>时间 <span>{{ticketorder.appointment_time }}</span></p>
					<p>{{site_name}}</p>
				</div>
			</div>
			<div class="fill_top_bottom">
				<div class="fill_sheets"><span>{{ticketorder.ticketnum}}</span>张</div>
				<div class="appointmentsheets">订单号：<span>{{ticketorder.orderno}}</span></div>
			</div>
		</div>
		<div v-if="codeShow" class="personnel_information">
			<p>参观人员信息</p>
			<ul class="information">
				<li v-for="(item,index) in ticketcodelist" v-show="index<num">
					<div class="information_left">
						<p>{{ticketcodelist[index].realname}}</p>
						<p v-if="!item.childnum" v-show="orderType==0">携带儿童数：0</p>
						<p v-if="item.childnum" v-show="orderType==0">携带儿童数：{{ticketcodelist[index].childnum}}</p>
						<div class="information_tips" v-if="ticketcodelist[index].status==1">
							<div><img src="../assets/success_yes.png" /></div>
							<div>审核通过</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==6">
							<div><img src="../assets/success_no.png" /></div>
							<div>审核未通过</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==5">
							<div><img src="../assets/success_no.png" /></div>
							<div>待审核</div>
						</div>
						<p>
							<span>{{ticketcodelist[index].idcard}}</span>
							<span v-if="ticketcodelist[index].telnum!=''">{{ticketcodelist[index].telnum}}</span>
						</p>
					</div>
				</li>
			</ul>
			<div class="success_more" v-show="success_more" @click="toBottom">
				<img v-if="toTop_toBot" src="../assets/toBottom.png" />
				<img v-else src="../assets/toTop.png" />
			</div>
		</div>
		<div v-if="!codeShow" class="personnel_information" style="margin-bottom: 80px;">
			<p>参观人员信息</p>
			<ul class="information">
				<li v-for="(item,index) in ticketcodelist" v-show="index<num">
					<div class="information_left">
						<p>{{ticketcodelist[index].realname}}</p>
						<p v-if="!item.childnum" v-show="orderType==0">携带儿童数：0</p>
						<p v-if="item.childnum" v-show="orderType==0">携带儿童数：{{ticketcodelist[index].childnum}}</p>
						<div class="information_tips" v-if="ticketcodelist[index].status==1">
							<div><img src="../assets/success_yes.png" /></div>
							<div>审核通过</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==6">
							<div><img src="../assets/success_no.png" /></div>
							<div>审核未通过</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==5">
							<div><img src="../assets/success_no.png" /></div>
							<div>待审核</div>
						</div>
						<p>
							<span>{{ticketcodelist[index].idcard}}</span>
							<span v-if="ticketcodelist[index].telnum!=''">{{ticketcodelist[index].telnum}}</span>
						</p>
					</div>
				</li>
			</ul>
			<div class="success_more" v-show="success_more" @click="toBottom">
				<img v-if="toTop_toBot" src="../assets/toBottom.png" />
				<img v-else src="../assets/toTop.png" />
			</div>
		</div>
		<div class="release_btn">
			<div class="release_btn_cli" @click="returnHome">返回首页</div>
		</div>
		<div class="success_QR_code" v-show="codeShow">
			<canvas id="canvas" ref="canva" style="display:none"></canvas>
			<img :src="imgUrl" />
			<a class="QR_code_btn" download="QRCode.png" :href="imgUrl">长按二维码保存到相册</a>
		</div>
		<!--<div class="preservation_success" v-show="preservation">
			<div class="success_center">
				<img src="../assets/success.png" />
				<p>保存完成</p>
				<div @click="determine">确定</div>
			</div>
		</div>-->
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	import QRCode from 'qrcode'
	export default {
		name: 'Success',
		data() {
			return {
				ticketActivity: [],
				ticketorder: [],
				ticketcodelist: [],
				site_name: "",
				num: 2,
				isShow: true,
				success_more: true,
				toTop_toBot: true,
				preservation: false,
				baseUrl: "",
				imgUrl: "",
				tano: "",
				phone: false,
				ordertype: "",
				idcardNum: 0,
				codeShow: true,
				orderType: ''
			}
		},
		components: {
			QRCode: QRCode
		},
		methods: {
			returnHome() {
				var that = this;
				if(sessionStorage.getItem('appointment_type') == 'ticket') {
					that.$router.push({
						name: 'Logo'
					});
				} else if(sessionStorage.getItem('appointment_type') == 'activity') {
					that.$router.push({
						name: 'ActivityRegistration'
					});
				}
			},
			useqrcode() {
				var that = this;
				let canvas = that.$refs.canva;
				var qrcode = 'orderid=' + that.orderid;
				QRCode.toCanvas(canvas, qrcode, function(error) {
					if(error) console.error(error)
				});
				that.imgUrl = canvas.toDataURL('image/png');
			},
			toBottom() {
				var that = this;
				that.isShow = !that.isShow;
				that.num = that.isShow ? 2 : that.ticketcodelist.length;
				if(that.isShow == false) {
					that.toTop_toBot = false;
				} else {
					that.toTop_toBot = true;
				}
			},
			determine() {
				var that = this;
				that.preservation = false;
				var mo = function(e) {
					e.preventDefault();
				};
				document.body.style.overflow = ''; //出现滚动条
				document.removeEventListener("touchmove", mo, false);
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.codeShow = true
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.codeShow = true
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.codeShow = false
			}
			that.baseUrl = baseUrl;
			that.orderid = sessionStorage.getItem("orderid");
			that.orderType = sessionStorage.getItem("orderType");
			that.site_name = sessionStorage.getItem("site_name");
			wclient.view.showLoading();
			$.ajax({
				type: "get",
				url: that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticketorder&action=ticketorderinfo&orderid=' + that.orderid,
				async: true,
				dataType: 'jsonp',
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				success: function(res) {
					wclient.view.hideLoading();
					//					for(var i = 0; i < res.ticketcodelist.length; i++) {
					//						if(res.ticketcodelist[i].certificate_type == 'idcard') {
					//							that.idcardNum += 1
					//						}
					//					}
					//					if(that.idcardNum == res.ticketcodelist.length) {
					//						that.codeShow = false
					//					} else {
					//						that.codeShow = true
					//					}
					that.ticketActivity = res.ticketActivity;
					that.ticketorder = res.ticketorder;
					that.ticketcodelist = res.ticketcodelist;
					that.tano = res.ticketActivity.tano;
					if(that.ticketcodelist.length < 3) {
						that.success_more = false
					};
					let photo_imageurl = that.ticketActivity.imageurl
					if(photo_imageurl.substring(0, 5) != "http") {
						that.photo = false;
					} else {
						that.photo = true;
					}
					that.useqrcode();
				}
			});
		}
	}
</script>

<style scoped>
	body {
		width: 100%;
		height: 100vh;
		background: #eee !important;
	}
	
	.container {
		float: left;
		width: 92%;
		display: block;
		padding: 0 4%;
		-webkit-overflow-scrolling: touch;
	}
	
	.fill_top {
		width: 90%;
		float: left;
		background: url(../assets/fill_top.png) center center no-repeat;
		background-size: 100% 100%;
		padding: 5%;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	
	.fill_top_head {
		float: left;
		width: 100%;
	}
	
	.fill_top_head_photo {
		float: left;
		width: 75px;
		height: 75px;
		margin-right: 5%;
		border-radius: 10px;
		overflow: hidden;
	}
	
	.fill_top_head_text {
		float: left;
		width: 66%;
		padding: 5px 0;
	}
	
	.fill_top_head_text p {
		width: 100%;
		color: #919CA2;
		font-size: 12px;
	}
	
	.fill_top_head_text p:nth-child(1) {
		margin-bottom: 5px;
		color: black;
		font-weight: 600;
		letter-spacing: 1px;
		font-size: 16px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}
	
	.fill_top_bottom {
		width: 100%;
		float: left;
		margin-top: 35px;
		display: flex;
		line-height: 20px;
		justify-content: space-between;
	}
	
	.fill_sheets {
		font-size: 16px;
		font-weight: 600;
	}
	
	.appointmentsheets {
		color: rgba(161, 168, 172, 1);
		font-size: 12px;
	}
	
	.personnel_information {
		float: left;
		width: 90%;
		padding: 10px 5%;
		background: white;
		border-radius: 10px;
	}
	
	.personnel_information>p {
		width: 100%;
		float: left;
		font-size: 16px;
		font-weight: 600;
	}
	
	.information {
		width: 100%;
		float: left;
		height: auto;
	}
	
	.information li {
		float: left;
		width: 100%;
		height: 70px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-top: 1px solid #eee;
	}
	
	.information li:nth-child(1) {
		border-top: none;
	}
	
	.information_left {
		color: rgba(180, 180, 180, 1);
		font-size: 14px;
		width: 100%;
	}
	
	.information_left p:nth-of-type(1) {
		float: left;
		margin-bottom: 10px;
		color: #585858;
		font-size: 14px;
		font-weight: 500;
		margin-right: 20px;
	}
	
	.information_left p:nth-of-type(2) {
		float: left;
		margin-bottom: 10px;
		color: #585858;
		font-size: 14px;
		font-weight: 500;
		margin-right: 20px;
	}
	
	.information_left p:nth-of-type(3) {
		width: 100%;
		float: left;
	}
	
	.information_left p:nth-of-type(3) span {
		margin-right: 30px;
	}
	
	.information_tips {
		float: left;
	}
	
	.information_tips>div:nth-of-type(1) {
		float: left;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		margin-top: 4px;
		margin-right: 5px;
	}
	
	.information_tips>div:nth-of-type(2) {
		float: left;
		font-size: 12px;
		color: #474747;
		line-height: 20px;
	}
	
	.success_more {
		width: 100%;
		float: left;
		margin-bottom: 8px;
		margin-top: 8px;
	}
	
	.success_more img {
		width: 4%;
		margin: 0 auto;
	}
	
	.success_QR_code {
		float: left;
		width: 100%;
		margin-bottom: 80px;
	}
	
	.success_QR_code img {
		width: 35%;
		margin: 0 auto;
		padding: 10px;
	}
	
	.QR_code_btn {
		margin: 0 auto;
		width: 70%;
		display: block;
		border-radius: 40px;
		color: black;
		line-height: 45px;
		text-align: center;
		font-size: 14px;
	}
	
	.preservation_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 25%;
		margin-left: 37%;
		margin-top: 30px;
	}
	
	.success_center p {
		width: 100%;
		color: black;
		font-size: 18px;
		font-weight: 600;
		text-align: center;
		margin-top: 20px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
	
	.release_btn {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background: white;
		padding: 15px 0;
		border-top: 1px solid #DBDBDB;
	}
	
	.release_btn_cli {
		width: 70%;
		margin: 0 auto;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 40px;
		text-align: center;
		color: white;
		border-radius: 20px;
		font-size: 14px;
	}
	
	p {
		margin-bottom: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/success.vue